/**
 * @summary main store mutations constants
 * @author Dominik Haas-Artho
 *
 * Created at     : 2019-10-23 16:34:51
 * Last modified  : 2020-10-13 22:47:19
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

export const SET_WEBP_ASSETS = 'SET_WEBP_ASSETS';
export const SET_JPG_ASSETS = 'SET_JPG_ASSETS';
export const SET_WEBP_SUPPORT = 'SET_WEBP_SUPPORT';
export const SET_CONTROLS = 'SET_CONTROLS';
export const SET_APP_SCROLL_POSITION = 'SET_APP_SCROLL_POSITION';
export const SET_BROWSE_SCROLL_POSITION = 'SET_BROWSE_SCROLL_POSITION';
export const SET_CONFIG = 'SET_CONFIG';
export const SET_CONFIG_SUCCESS = 'SET_CONFIG_SUCCESS';
export const SET_CONFIG_ERROR = 'SET_CONFIG_ERROR';
export const CHECK_FRONTEND_VERSION = 'CHECK_FRONTEND_VERSION';
export const CHECK_FRONTEND_VERSION_NEW = 'CHECK_FRONTEND_VERSION_NEW';
export const GENERIC_API_ERROR = 'GENERIC_API_ERROR';
export const ADD_USER_NOTIFICATION = 'ADD_USER_NOTIFICATION';
export const TRIM_NOTIFICATIONS = 'TRIM_NOTIFICATIONS';
export const HIDE_NOTIFICATIONS = 'HIDE_NOTIFICATIONS';

export const AUTHOR_ASCII_DEAD = '&#8224;';
export const AUTHOR_PASSED_INFO = 'Sadly this author has passed away.';
